<template lang="html">
  <div
    v-if="showStatusBar"
    class="lbv-status-bar"
  >
    <b-alert
      fade
      dismissible
      :show="successDismiss"
      variant="success"
      @dismissed="successDismiss=0"
    >
      {{ success }}
    </b-alert>
    <b-alert
      fade
      dismissible
      :show="warningDismiss"
      variant="warning"
      @dismissed="warningDismiss=0"
    >
      {{ warning }}
    </b-alert>
    <b-alert
      fade
      dismissible
      :show="error != ''"
      variant="danger"
      @dismissed="error = ''"
    >
      {{ error }}
    </b-alert>
  </div>
</template>

<script>
import { EventBus } from '../../event-bus'
import { StatusBarEvent } from '../../events/statusBarEvent'

export default {
  name: 'StatusBar',
  data () {
    return {
      error: '',
      errorDismiss: 0,
      success: '',
      successDismiss: 0,
      warning: '',
      warningDismiss: 0
    }
  },
  computed: {
    showStatusBar () {
      return this.error !== '' || this.successDismiss + this.warningDismiss !== 0
    }
  },
  created () {
    EventBus.$on(StatusBarEvent.SUCCESS, this.showSuccess)
    EventBus.$on(StatusBarEvent.WARNING, this.showWarning)
    EventBus.$on(StatusBarEvent.ERROR, this.showError)
  },
  methods: {
    showSuccess (message) {
      this.success = message
      this.successDismiss = 3
    },
    showWarning (message) {
      this.warning = message
      this.warningDismiss = 3
    },
    showError (message) {
      this.error = message
    }
  }
}
</script>

<style lang="css">
  .lbv-status-bar {
    position: fixed;
    bottom: 0px;
    width: 100%;
    height: 47px;
    z-index: 1100;
  }

  .lbv-status-bar .alert {
    margin-bottom: 0;
  }

  .lbv-status-bar .alert.custom-fade {
    transition: opacity 1s;
  }

</style>
